var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStaffWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#ED1B2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#staff_wide_svg__clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.75 36.5c-4.825 0-8.75-3.925-8.75-8.75S29.925 19 34.75 19s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75zM27.313 40C22.727 40 19 43.727 19 48.313v6.124c0 .718.595 1.313 1.313 1.313H36.5v-5.688c0-3.29 2.45-6.002 5.617-6.474a6.73 6.73 0 012.416-3.255c-1.75-.501-1.845-.333-17.22-.333zM57.938 47H55.75v-1.313a3.066 3.066 0 00-3.063-3.062h-4.374a3.066 3.066 0 00-3.063 3.063V47h-2.188c-.86 0-1.636.359-2.192.933l9.63 5.024 9.63-5.024A3.044 3.044 0 0057.937 47zm-10.063 0v-1.313c0-.241.196-.437.438-.437h4.374c.242 0 .438.196.438.438V47h-5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.107 55.601c-.38.198-.834.198-1.212 0L40 50.44v7.498A3.066 3.066 0 0043.063 61h14.874A3.066 3.066 0 0061 57.937V50.44L51.107 55.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "staff_wide_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(19 19)",
    d: "M0 0h42v42H0z"
  })))));
}

export default SvgStaffWide;